import React, { useEffect } from "react";
import { IonApp, setupIonicReact } from "@ionic/react";
import Routing from "./routes";

import { setToken } from "services/auth";
import { setLoading } from "services/loading";

import { ToastProvider } from "components/Toast/toast";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "theme/variables.css";
import "theme/global.scss";
import "theme/styles.css";

setupIonicReact();

const App: React.FC = () => {
  useEffect(() => {
    setToken();
    setLoading(false);
  }, []);

  return (
    <IonApp>
      <ToastProvider>
        <Routing />
      </ToastProvider>
    </IonApp>
  );
};

export default App;
